import { render, staticRenderFns } from "./ManageSettlementsInDefault.vue?vue&type=template&id=7d2fd049&scoped=true"
import script from "./ManageSettlementsInDefault.vue?vue&type=script&lang=js"
export * from "./ManageSettlementsInDefault.vue?vue&type=script&lang=js"
import style0 from "./ManageSettlementsInDefault.vue?vue&type=style&index=0&id=7d2fd049&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2fd049",
  null
  
)

export default component.exports